import type { SendSmsRequest, SendSmsResponse } from "@przezmorze/api-types";
import { przezmorzeApi, throwMessageOnStatuses } from "../../api/api";

export type { SendSmsRequest, SendSmsResponse };

export async function sendSms(request: SendSmsRequest): Promise<SendSmsResponse> {
  try {
    const response = await przezmorzeApi.post<SendSmsResponse>("/sms", request);
    return response.data;
  } catch (error) {
    throwMessageOnStatuses(error, [400, 409, 503]);
  }
}
